module.exports = __webpack_public_path__ + "static/media/3.cd6c2801.svg";